import { render } from "./TableImage.vue?vue&type=template&id=32e5aaa7&ts=true"
import script from "./TableImage.vue?vue&type=script&lang=ts"
export * from "./TableImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__